export const PAYMENT_ALERT_DEFAULT_MESSAGE =
  "Please extend the subscription till {END DATE}. Don't lose your access to the platform.";
